import { useEffect } from 'react';
import { WebBlocksApiBlockT } from '../REST/types';
import { ApiResponseType } from './Track';
import {
	TrackApiError,
	TrackApiNoResponse,
	TrackApiSuccess,
} from './TrackingFunctions';

function getCampaignIds(result?: WebBlocksApiBlockT[]) {
	return result !== undefined ? result?.map((t) => t.campaignId).join(',') : '';
}

function getBlockContenIds(result?: WebBlocksApiBlockT[]) {
	return result !== undefined ? result?.map((t) => t.contentId).join(',') : '';
}

function handleApiResponse(
	apiResponse: ApiResponseType,
	ratAccountId: string,
	ratServiceType: string,
	isMobile: boolean
) {
	if (apiResponse.isFetching === true) {
		return null;
	}

	const apiTrackingBaseParameters = {
		ratAccountId,
		ratServiceType,
		isMobile,
	};

	if (apiResponse.error) {
		return TrackApiError({
			...apiTrackingBaseParameters,
			error: apiResponse.error,
		});
	}
	if (!apiResponse.result || apiResponse.result.length < 1) {
		return TrackApiNoResponse(apiTrackingBaseParameters);
	}
	return TrackApiSuccess({
		...apiTrackingBaseParameters,
		data: apiResponse.result,
		campaignId: getCampaignIds(apiResponse.result),
		contentId: getBlockContenIds(apiResponse.result),
	});
}

export function useSendApiTrackingToRat(
	apiResponse: ApiResponseType,
	ratAccountId: string,
	ratServiceType: string,
	isMobile: boolean
) {
	useEffect(() => {
		handleApiResponse(apiResponse, ratAccountId, ratServiceType, isMobile);
	}, [apiResponse]);
}
